import React from "react";
import {Checkbox} from "antd";

const CheckboxGroup = React.forwardRef(({items, ...props}, ref) => <Checkbox.Group className="arpec-input-checkbox-group" options={items} {...props} ref={ref}/>)

export default CheckboxGroup;
